import { render, staticRenderFns } from "./WidgetWordList.vue?vue&type=template&id=df067582&"
import script from "./WidgetWordList.vue?vue&type=script&lang=js&"
export * from "./WidgetWordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetWordList.vue"
export default component.exports